import { actionTypes } from '../../types';

// Action creator for requesting agency list by status
export const markApprovedRejectedAgency = (payload) => ({
    type: actionTypes.MARK_APPROVED_REJECTED_AGENCY_REQUEST,
    payload,
});

// Action creator on success
export const markApprovedRejectedAgencySuccess = (payload) => ({
    type: actionTypes.MARK_APPROVED_REJECTED_AGENCY_SUCCESS,
    payload,
});

// Action creator on failure
export const markApprovedRejectedAgencyFailure = (payload) => ({
    type: actionTypes.MARK_APPROVED_REJECTED_AGENCY_FAILURE,
    payload,
});

// Reset status/message only
export const markApprovedRejectedAgencyReset = () => ({
    type: actionTypes.MARK_APPROVED_REJECTED_AGENCY_RESET,
});

// Reset whole reducer to initial state
export const markApprovedRejectedAgencyResetAll = () => ({
    type: actionTypes.MARK_APPROVED_REJECTED_AGENCY_RESET_ALL,
});
